<template>
  <div class="extract-box" v-show="showExtract">
    <div class="extract" v-if="showTurntable" @click.stop="showExtract = false">
      <div class="title">
        <img v-if="type == 1" src="@/assets/img/turntable_new.png" />
        <img v-if="type == 2" src="@/assets/img/turntable_integral.png" />
      </div>
      <div class="turntable">
        <LuckyWheel
          class="lucky-wheel"
          ref="myLuck"
          :width="width"
          :height="height"
          :prizes="prizes"
          :blocks="blocks"
          :defaultConfig="defaultConfig"
          @end="endCallback"
        />
        <button
          class="startBtn"
          :disabled="isPlay"
          @click.stop="startCallback"
        ></button>
      </div>
      <button class="startBtn2" :disabled="isPlay" @click.stop="startCallback">
        立即抽奖
      </button>
    </div>
    <div class="grant-box integral-grant" v-if="showGrant && integralGrant">
      <div class="grant">
        <img
          src="@/assets/img/grant_close.png"
          class="close"
          @click.stop="close"
        />
        <h2>奖励发放</h2>
        <h3>
          恭喜您! 抽中
          <span>{{ grant.quota }}</span>
          积分
        </h3>
        <p>可在福利中心消耗积分抽取现金奖励!</p>
        <div class="integral">{{ grant.title }}</div>
        <button class="btn" @click.stop="close">我知道了</button>
        <span class="hand"></span>
      </div>
    </div>
    <div class="grant-box cash-grant" v-if="showGrant && cashGrant">
      <div class="grant">
        <img
          src="@/assets/img/grant_close.png"
          class="close"
          @click.stop="close"
        />
        <h2>奖励发放</h2>
        <h3>
          恭喜您! 抽中
          <span>{{ grant.quota }}</span>
          元现金
        </h3>
        <p>
          请您凭借此二维码在微信福利群中
          <br />
          兑换现金奖励!
        </p>
        <div class="cash">
          <img :src="codeText" />
        </div>
        <button class="btn" @click.stop="save">保存二维码</button>
      </div>
    </div>
  </div>
</template>

<script>
import turntable from '@/assets/img/turntable.png'
import img from '@/assets/img/turntable_go.png'
import integralIcon from '@/assets/img/integralIcon.png'
import cashIcon from '@/assets/img/cashIcon.png'
import { activityDraw, getCodeInfo } from '@/api/activity'
export default {
  name: 'extract',
  props: {
    type: {
      type: String,
      default: '',
    },
    activityId: {
      type: String,
      default: '',
    },
    turntableData: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      showExtract: false,
      showTurntable: true,
      showGrant: false,
      integralGrant: false,
      cashGrant: false,
      userCode: '',
      isPlay: false,
      width: '79.82vw',
      height: '79.95vw',
      blocks: [
        {
          padding: '8.7vw',
          imgs: [
            {
              width: '100%',
              height: '100%',
              src: turntable,
              rotate: true,
            },
          ],
        },
      ],
      prizes: [],
      defaultConfig: {
        gutter: '1px',
      },
      index: null,
      grant: {},
      codeText: '',
      id: '',
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    activityId(val) {
      this.activityId = val
      this.init()
    },
  },
  methods: {
    async init() {

      this.prizes = this.turntableData
      this.prizes = this.prizes.map((item, index) => ({
        fonts: [
          {
            text: item.prizeName,
            top: '3.5vw',
            fontColor: '#F52B10',
            fontSize: '4.42vw',
            wordWrap: false,
          },
        ],
        imgs: [
          {
            src: item.prizeType == '0001' ? integralIcon : cashIcon,
            top: '10vw',
            width: '6vw',
            height: '6vw',
          },
        ],
        background: index % 2 ? '#FFEFE3' : '#FFFBF5',
        rate: item.rate,
        prizeType: item.prizeType,
        prizeId: item.prizeId,
        quota: item.quota,
      }))
      console.log(this.prizes)
    },
    close() {
      this.showExtract = false
      this.showGrant = false
      this.showTurntable = true
    },
    save() {
      const url = this.codeText
      window.location.href =
        'appdjxhealth://actionSavePicture?picUrl=' + url
      this.showExtract = false
      this.showGrant = false
      this.showTurntable = true
    },
    async startCallback() {
      let data = {
        id: this.activityId,
        acitivityType: this.type,
      }
      let res = await activityDraw(data)
      if (res.code == '1000') {
        this.isPlay = true
        //调用抽奖组件的play方法开始
        this.$refs.myLuck.play()
        setTimeout(() => {
          // 调用stop停止旋转并传递中奖索引
          console.log(this.index)
          this.$refs.myLuck.stop(this.index)
        }, 3000)
        this.prizes.forEach((item, index) => {
          console.log(res.data.prizeId)
          console.log(item.prizeId)
          if (res.data.prizeId == item.prizeId) {
            this.id = res.data.id
            this.index = index
          }
        })
      }
    },
    // 抽奖结束会触发end回调
    async endCallback(prize) {
      console.log(this.index)
      this.isPlay = false
      this.grant = {
        quota: prize.quota,
        title: prize.fonts[0].text,
      }
      this.showGrant = true
      this.showTurntable = false
      this.$parent.init()
      if (prize.prizeType == '0001') {
        this.integralGrant = true
      } else {
        const params = {
          reqUrl:
            'http://' +
            SEVSRS.split('//')[1].split('/')[0] +
            '/h5/#/writeOff?id=' +
            this.id,
          id: this.id,
        }
        let res = await getCodeInfo(params)
        if (res.code == '1000') {
          this.codeText = res.data.url
          this.cashGrant = true
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.extract-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
@keyframes rotato {
  0% {
    transition: rotate(0deg);
  }
  100% {
    transition: rotate(360deg);
  }
}
.extract {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  background-image: url('~@/assets/img/turntable_bg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 17vh;
  .title {
    height: 6.75vh;
    text-align: center;
    img {
      display: inline-block;
      height: 100%;
    }
  }
  .turntable * {
    animation-play-state: paused !important;
  }
  .turntable {
    width: 79.82vw;
    height: 46.125vh;
    margin: 2.25vh auto;
    position: relative;
    .lucky-wheel * {
      width: 100% !important;
      height: 100% !important;
    }
    .lucky-wheel {
      margin: auto;

      // width: 79.95vw;
      // height: 79.95vw;
      // padding: '8.7vw';
      // background: url('~@/assets/img/turntable.png') no-repeat;
      // background-size: 100% 100%;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // position: relative;
      // animation: rotato 20s linear infinite forwards;
      canvas {
        width: 100% !important;
        height: 100% !important;
        transform-origin: left top;
        transform: scale(1) !important;
      }
    }
    .startBtn {
      position: absolute;
      background: url('~@/assets/img/turntable_go.png') no-repeat;
      background-size: 100% 100%;
      width: 22.23vw;
      height: 26.39vw;
      left: 28.99vw;
      top: 13.575vh;
      z-index: 100;
      border: none;
    }
  }
  .startBtn2 {
    display: block;
    background: url('~@/assets/img/btn_bg.png') no-repeat;
    background-size: 100% 100%;
    width: 50.7vw;
    height: 8.325vh;
    margin: 2.25vh auto;
    z-index: 100;
    border: none;
    font-weight: 600;
    color: #fffbf5;
    text-shadow: 0px 2px 0px rgba(10, 31, 62, 0.15);
    font-size: 5.72vw;
    border-radius: 18.5vw;
  }
}
.grant-box {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .grant {
    width: 68vw;
    background: linear-gradient(7deg, #fdf4d9, #ffffff);
    border: 0.26vw solid #ffffff;
    border-radius: 6.37vw;
    margin: 0 auto;
    height: auto;
    position: relative;
    .close {
      width: 4.94vw;
      height: 4.94vw;
      position: absolute;
      right: 0;
      top: -3.9vh;
    }
    h2 {
      width: 28vw;
      height: 3.7vh;
      background: linear-gradient(-34deg, #ffe391, #ffedb6);
      border-radius: 0px 0px 2.34vw 2.34vw;
      margin: -0.2vh auto;
      color: #872306;
      font-size: 3.77vw;
      text-align: center;
      line-height: 3.7vh;
    }
    h3 {
      text-align: center;
      font-family: zihunxingmouhei_trial;
      font-weight: 600;
      color: #872306;
      margin-top: 3vh;
      font-size: 4.42vw;
      span {
        color: #ff5958;
      }
    }
    p {
      font-family: PingFang SC;
      color: #872306;
      text-align: center;
      font-size: 2.99vw;
      margin: 1.425vh 0 2.925vh;
    }
    .integral {
      width: 59.93vw;
      height: 16.275vh;
      background: url('~@/assets/img/grant_integral_bg.png') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 16.275vh;
      font-family: zihunxingmouhei_trial;
      font-weight: 600;
      color: #feecb4;
      font-size: 6.37vw;
      margin: 0 auto;
    }
    .btn {
      border: none;
      display: block;
      background: url('~@/assets/img/btn_bg.png') no-repeat;
      background-size: 100% 100%;
      width: 50.7vw;
      height: 8.325vh;
      font-weight: 600;
      color: #fffbf5;
      text-shadow: 0px 2px 0px rgba(10, 31, 62, 0.15);
      font-size: 5.72vw;
      margin: -3vh auto 4vh;
    }
    .hand {
      width: 13.26vw;
      height: 12.15vh;
      background: url('~@/assets/img/grant_hand.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 7.4vw;
      bottom: -4.35vh;
    }
    .cash {
      width: 25.22vw;
      height: 25.22vw;
      background: url('~@/assets/img/grant_code.png') no-repeat;
      background-size: 100% 100%;
      margin: 2.25vh auto 7vh;
      padding: 0.4vw;
      img {
        border-radius: 2vw;
        width: 100%;
      }
    }
  }
}
.integral-grant {
  background-image: url('~@/assets/img/grant_bg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 32vh;
}
.cash-grant {
  background-image: url('~@/assets/img/grant_bg2.png');
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 27vh;
}
</style>


// WEBPACK FOOTER //
// src/views/components/ExtractTurntable.vue